import { render, staticRenderFns } from "./jubao.vue?vue&type=template&id=5b7cc732"
import script from "./jubao.vue?vue&type=script&lang=js"
export * from "./jubao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports